import React from 'react';

import { get } from 'lodash';
import {
  required,
  SelectInput,
  TextInput,
} from 'react-admin';
import {
  useForm,
  useFormState,
} from 'react-final-form';

import { Grid } from '@material-ui/core';

import taxTypes from '../tax_types';

const TaxInput = ({ source, ...props }) => {
	const formState = useFormState();
	const taxType = get(formState.values, `${source}tax_type`, null);
	const form = useForm();
	return (
		<Grid container>
			<SelectInput
				source={`${source}tax_type`}
				choices={taxTypes}
				validate={required()}
				onChange={(e) => {
					if (e.target.value === "person") {
						form.change("e_invoice", false);
					}
				}}
				{...props}
			/>
			{taxType && taxType === "company" && (
				<SelectInput
					choices={[
						{ id: false, name: "ra.action.no" },
						{ id: true, name: "ra.action.yes" },
					]}
					source={`${source}e_invoice`}
					label={`resources.users.fields.profile.e_invoice`}
					{...props}
				/>
			)}
			{taxType && (
				<TextInput
					source={`${source}vat_code`}
					label={`resources.users.fields.profile.vat_code_${taxType}`}
					validate={required()}
					{...props}
				/>
			)}
		</Grid>
	);
};

export default TaxInput;
